var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var PreparationIcon = function (_a) {
    var kind = _a.kind, props = __rest(_a, ["kind"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round" }, props),
        kind === 'face' && (React.createElement(React.Fragment, null,
            React.createElement("path", { d: "M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M8 21H5a2 2 0 0 1-2-2v-3" }),
            React.createElement("path", { d: "M9 9h.01M15 9h.01M8 14a4.5 4.5 0 0 0 8 0" }))),
        kind === 'sun' && (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: "12", cy: "12", r: "3.5" }),
            React.createElement("path", { d: "M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" }))),
        kind === 'glasses' && (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: "6", cy: "15", r: "4" }),
            React.createElement("circle", { cx: "18", cy: "15", r: "4" }),
            React.createElement("path", { d: "M10 14h4M2 14l2-9h2M22 14l-2-9h-2" }))),
        kind === 'eye' && (React.createElement(React.Fragment, null,
            React.createElement("path", { d: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" }),
            React.createElement("circle", { cx: "12", cy: "12", r: "3" }))),
        kind === 'shield' && (React.createElement(React.Fragment, null,
            React.createElement("path", { d: "M12 3 4.5 6v5.5c0 4.7 3.2 7.5 7.5 9.5 4.3-2 7.5-4.8 7.5-9.5V6L12 3Z" }),
            React.createElement("path", { d: "m8.5 12 2.3 2.3 4.7-4.7" })))));
};
export default PreparationIcon;
